// extracted by mini-css-extract-plugin
export default {"logoSwiper":"logo_slide_logoSwiper__jqnzh","logoContainer":"logo_slide_logoContainer__lxnFS"};